/**
 * Eligibility Cases
 */

export const Eligibility = Object.freeze({
  SERVING: 'Currently serving',
  EX_SERVING: 'Ex-serving',
  WORK_CONNECTION: 'Work Connection',
  RELATED: 'Supporting',
  CONTRACTOR: 'Contractor',
  DPS: 'Defence Public Service',
});

export default Eligibility;
